import * as A from "fp-ts/Array";
import { identity, pipe } from "fp-ts/function";
import { concatAll } from "fp-ts/Monoid";
import * as R from "fp-ts/Record";
import { first } from "fp-ts/Semigroup";
import * as T from "fp-ts/Tuple";
import { firstRight } from "../../../fp-utils";
import * as SRT from "../struct-refined-types";
const mergeJsonMap = R.getMonoid(first());
const toRecord = ([k, v]) => ({ [k]: v });
const convertStructToJson = (message) => pipe(
  message.fields,
  Object.entries,
  A.map(T.bimap(convertValueToJson, identity)),
  A.map(toRecord),
  concatAll(mergeJsonMap)
);
const convertValueToJson = (message) => firstRight(message, null, [
  [SRT.isBoolValue, ({ boolValue }) => boolValue],
  [SRT.isNumberValue, ({ numberValue }) => numberValue],
  [SRT.isStringValue, ({ stringValue }) => stringValue],
  [SRT.isNullValue, () => null],
  [SRT.isArrayValue, (m) => convertListToJson(m.listValue || { values: [] })],
  [SRT.isStructValue, (m) => convertStructToJson(m.structValue || { fields: {} })]
]);
const convertListToJson = (message) => pipe(message.values, A.map(convertValueToJson));
export {
  convertStructToJson
};
//# sourceMappingURL=convertStructToJson.js.map
